import Vue from 'vue'
import Router, { Route } from 'vue-router'
import Home from './components/Home.vue'
import Tags from './components/Tags/Tags.vue'
import AddTag from './components/Tags/AddTag.vue'

import Files from './components/Files/Files.vue'
import AddFile from './components/Files/AddFile.vue'

import Users from './components/Users/Users.vue'
import AddUser from './components/Users/AddUser.vue'

import Headerfiles from './components/Headerfiles/Addheaderfile.vue'

import FooterImages from './components/FooterImages/FooterImages.vue'
import AddFooterImages from './components/FooterImages/AddFooterImages.vue'

import Login from './components/Login.vue'
import API from '@/store/api';
import Addheaderfile from './components/Headerfiles/Addheaderfile.vue'
Vue.use(Router);

export const routes = [
    {
        path: '/',
        name: 'Start',
        component: Home
    },
    {
        path: '/Tags',
        name: 'Tags',
        component: Tags
    },
    {
        path: '/Tags/add',
        name: 'TagsAdd',
        component: AddTag
    },
    {
        path: '/Tags/:tagtypeid',
        name: 'Tagselected',
        component: Tags,
        props: { default: true }
    },
    {
        path: '/Tags/edit/:tagtypeid/:tagid',
        name: 'TagsEdit',
        component: AddTag,
        props: { default: true }
    },
    {
        path: '/Files',
        name: 'Files',
        component: Files
    },
    {
        path: '/Files/add',
        name: 'FileAdd',
        component: AddFile
    },
    {
        path: '/Files/edit/:fileId',
        name: 'FileEdit',
        component: AddFile,
        props: { default: true }
    },

    {
        path: '/',
        name: 'FileEdit',
        component: AddFile,
        props: { default: true }
    },

    {
        path: '/Users',
        name: 'Users',
        component: Users,
        icon: 'ti-home'
    },
    {
        path: '/Users/add',
        name: 'UsersAdd',
        component: AddUser,
        icon: 'ti-home',
        meta: {
            restricted: true
        },
    },
    {
        path: '/Users/edit/:userId',
        name: 'UsersEdit',
        component: AddUser,
        icon: 'ti-home',
        meta: {
            restricted: true
        },

    },
    {
        path: '/FooterImages',
        name: 'FooterImages',
        component: FooterImages,
        icon: 'ti-home'
    },
    {
        path: '/FooterImages/add',
        name: 'FooterImagesAdd',
        component: AddFooterImages,
        icon: 'ti-home',
        meta: {
            restricted: true
        },
    },
    {
        path: '/headerfiles/addheaderfile',
        name: 'AddHeaderFile',
        component: Addheaderfile,
        icon: 'ti-home'
    },

    {
        path: '/Login',
        name: 'Login',
        component: Login,
        icon: 'ti-home'
    },
]




const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

API.isAuthenticated();
const isAuthenticated =  API.checkauth();

router.beforeEach((to, from, next) => {
   
    if ((to.name !== 'Login' && to.name !== 'Start') && isAuthenticated=='false') {
       
        next({ name: 'Login' })
    }
    
    else {

        next()
    }
})

export default router
